import SummaryTable from 'common/components/table/SummaryTable';

interface IResidenceDisplay {
  files: {
    name: string;
    description: string;
  }[];
}

const ResidenceDisplay = (props: IResidenceDisplay) => {
  const { files } = props;
  return (
    <>
      <h4>Existing Documents</h4>

      {files.map((file, index) => (
        <>
          <span>
            {index === 0 ? 'ID or Drivers License' : 'Supplementary Document'}{' '}
          </span>
          <SummaryTable
            data={[
              {
                label: 'Name:',
                value: file.name,
              },
              {
                label: 'Attachment type:',
                value: file.description,
              },
            ]}
          />
        </>
      ))}
    </>
  );
};

export default ResidenceDisplay;
